export type EditableInteger = number | "";

export function editableInteger(rawValue: string): EditableInteger {
  if (rawValue === "") return "";
  const value = Number(rawValue);
  return Number.isInteger(value) ? value : "";
}
